/**
 * <promo-banner-narrow>
 * Shows one of the server-rendered banners, picked at random.
 * Until it runs, CSS shows the first banner, so the slot never collapses.
 */
if (!customElements.get('promo-banner-narrow')) {
  customElements.define(
    'promo-banner-narrow',
    class PromoBannerNarrow extends HTMLElement {
      connectedCallback() {
        const items = this.querySelectorAll('.promo-banner-narrow__item');
        if (!items.length) return;

        const picked = items[Math.floor(Math.random() * items.length)];
        for (const item of items) item.classList.toggle('is-active', item === picked);
        this.classList.add('is-ready');
      }
    },
  );
}
